<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="full-width">
    <div class="primary-title xtium-title mb-3">{{ $t('colorSettings') }}</div>
    <EcsColorPicker
      v-for="picker in colorPickers"
      :key="picker.title"
      :color-key="picker.colorKey"
      :title="picker.title"
      :color="picker.color"
      :disabled="disableControls"
      @colorChange="colorChange"
    />
  </div>
</template>

<script>
import EcsColorPicker from '@/components/ecs-color-picker/EcsColorPicker';
import EcsDisableControlsMixin from '@/mixins/EcsDisableControlsMixin';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EcsColorSettings',
  components: { EcsColorPicker },
  mixins: [EcsDisableControlsMixin],
  computed: {
    ...mapGetters(['theme']),
    colorPickers() {
      if (!this.theme) {
        return [];
      }
      const pickerColors = this.theme.getThemeMode ? this.theme.getThemeColors.dark : this.theme.getThemeColors.light;
      return [
        {
          colorKey: 'primary',
          title: 'primary',
          color: pickerColors.primary
        },
        {
          colorKey: 'secondary',
          title: 'accent',
          color: pickerColors.secondary
        },
        {
          colorKey: 'surface',
          title: 'background',
          color: pickerColors.surface
        }
      ];
    }
  },
  methods: {
    ...mapActions(['setThemeColor']),
    colorChange(color, key) {
      this.setThemeColor({ payload: { key, color }, vuetify: this.$vuetify });
      this.$forceUpdate();
    }
  }
};
</script>

<style></style>
